import { Route, Routes } from 'react-router-dom';

import Layout from '@/components/globals/Layout';
import PrivateRoute from '@/components/globals/PrivateRoute';
import RedirectOldUrlRouter from '@/components/globals/RedirectOldUrlRouter';
import RedirectRouter from '@/components/globals/RedirectRouter';
import ScrollToTop from '@/components/globals/ScrollToTop';
import Certificates from '@/pages/Certificates';
import Content from '@/pages/Content';
import Course from '@/pages/Course';
import Help from '@/pages/Help';
import Invite from '@/pages/Invite';
import Lesson from '@/pages/Lesson';
import MyCourses from '@/pages/MyCourses';
import Notes from '@/pages/Notes';
import Notifications from '@/pages/Notifications';
import Portals from '@/pages/Portals';
import Profile from '@/pages/Profile';
import Resume from '@/pages/Resume';
import SavedLessons from '@/pages/SavedLessons';
import Unsubscribe from '@/pages/Unsubscribe';

import CoursesFromPackage from './CoursesFromPackage';
import MyPackages from './MyPackages';
import NotificationCenter from './NotificationCenter';
import ShelfCourses from './ShelfCourses';

function AppRoutes() {
  const publicRoutes = (
    <Route path='/' element={<Layout />}>
      <Route path='/curso/:hash/:slug?' element={<Course />} />
      <Route path='/curso/:hash/:slug?/aula/:id' element={<Lesson />} />
      <Route path='/unsubscribe/:trackId' element={<Unsubscribe />} />
      <Route path='/' element={<RedirectRouter />} />
    </Route>
  );
  const privateRoutes = (
    <Route
      path='/'
      element={
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      }
    >
      <Route path='/conteudo/:courseHash/:lessonId?' element={<Content />} />
      <Route path='/convite/:courseHash/:inviteId' element={<Invite />} />
      <Route path='/resumo' element={<Resume />} />
      <Route path='/certificados' element={<Certificates />} />
      <Route path='/cursos' element={<MyCourses />} />
      <Route path='/trilha/:shelfId' element={<ShelfCourses />} />
      <Route path='/pacote/:hash' element={<CoursesFromPackage />} />
      <Route path='/pacotes/' element={<MyPackages />} />
      <Route path='/portais' element={<Portals />} />
      <Route path='/aulas/salvas' element={<SavedLessons />} />
      <Route path='/notas' element={<Notes />} />
      <Route path='/notificacoes' element={<Notifications />} />
      <Route path='/ajuda' element={<Help />} />
      <Route path='/perfil' element={<Profile />} />
      <Route path='/central-notificacoes' element={<NotificationCenter />} />
    </Route>
  );

  const redirectRoutes = (
    <>
      <Route path='/v3/*' element={<RedirectOldUrlRouter />} />
      <Route path='/*' element={<RedirectRouter />} />
    </>
  );

  return (
    <ScrollToTop>
      <Routes>
        {publicRoutes}
        {privateRoutes}
        {redirectRoutes}
      </Routes>
    </ScrollToTop>
  );
}

export default AppRoutes;
